import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';

export interface CourseState {
  chimeraCourses?: ChimeraCourseModel[] | null;
}

const state: CourseState = {
  chimeraCourses: [],
};

export default state;
